import { TbaComparableAnalysis as Component } from './component';
import Connector from './connector';

export const TbaComparableAnalysis = () => {
  return <Connector component={Component} />;
};
